import React from 'react';
import { View, StyleSheet } from 'react-native';
import R from '../../core-res/R';
import PropTypes from 'prop-types';
import { withTheme } from '../../theme';
class CarouselPaginationDot extends React.Component {
    render() {
        const { isActive, dotStyle, activeDotStyle, theme } = this.props;
        const style = [styles.dot, { backgroundColor: theme.lightSecondary }, dotStyle];
        if (isActive) {
            style.push(...[{ backgroundColor: theme.tintPrimary }, activeDotStyle]);
        }
        return <View style={style}/>;
    }
}
CarouselPaginationDot.propTypes = {
    isActive: PropTypes.bool,
    dotStyle: PropTypes.object,
    activeDotStyle: PropTypes.object,
    theme: PropTypes.object,
};
CarouselPaginationDot.defaultProps = {
    isActive: false,
};
const styles = StyleSheet.create({
    dot: {
        height: 12,
        width: 12,
        borderRadius: R.border.radius.rounded,
        margin: R.spacing.xxs,
    },
});
export default withTheme(CarouselPaginationDot);
